import { createSlice } from '@reduxjs/toolkit';
import {initialState} from '../../../../data/entitlement/entitlements/entitlementsSiteActivity/initialState.entitlementsSiteActivity.data';
import {
  fetchEntitlementSiteActivityData as fetchEntitlementSiteActivityDataAPI,
  entitlementSiteActivityJob as entitlementSiteActivityJobAPI,
} from '../../../../apis/entitlementsSiteActivityAPI';
import { handlePending, handleRejection } from '../../../../constants';
import { createAsyncThunkWrapper } from '../../../../services/common/asyncThunkWrapper';
import { ACTIONS_ENTITLEMENT_SITEACTIVITY } from '../../../../constants/actionCreator';

//API to get data by Entitlement Id for Entitlements
export const fetchEntitlementsSiteActivity = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_SITEACTIVITY.FETCH_SITE_ACTIVITY,
  fetchEntitlementSiteActivityDataAPI
);

export const entitlementSiteActivityJobRun = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_SITEACTIVITY.SITE_ACTIVITY_JOB,
  entitlementSiteActivityJobAPI
);

const entitlementsSiteActivitySlice = createSlice({
  name: 'entitlementsSiteActivity',
  initialState,
  reducers: {
    //handle Selected Tab
    handleSelectedTab: (state, action) => {
      state.selectededTab = action.payload;
    },
    //handle Selected Row
    handleEntitlementsSiteActivitySelectedRow: (state, action) => {
      state.entitlementsSiteActivitySelectedRow = action.payload;
    },
    siteIdSet: (state, action) => {
      state.reqSiteId = action.payload;
    },
    setReq: (state, action) => {
      const {
        Site_Id,
        Site_Activity_Type_Id,
        Activity_Date,
        Entitlement_Site_List,
        Invoice_Number,
        Dest_Site_Id,
        Entitlement_Upgrade_List,
        Entitlement_Install_List,
        SiteActivityId,
        Disassemble,
        Waiting,
        User_Id,
      } = action?.payload;
      state.jobRunReqTransfer = {
        ...state.jobRunReqTransfer,
        Site_Id,
        Site_Activity_Type_Id,
        Activity_Date,
        Entitlement_Site_List,
        Invoice_Number,
        Dest_Site_Id,
        Entitlement_Upgrade_List,
        Entitlement_Install_List,
        SiteActivityId,
        Disassemble,
        Waiting,
        User_Id,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEntitlementsSiteActivity.pending, (state, action) => {
        handlePending(state, action);
        state.entitlementsSiteActivityData = [];
        state.isEntitlementsSiteActivityResultsFound = null;
        state.isEntitlementsLoading = true;
        state.entitlementsSiteActivityTotalRecords = 0;
      })
      .addCase(fetchEntitlementsSiteActivity.fulfilled, (state, action) => {
        state.loading = false;
        state.entitlementsSiteActivityData = action?.payload
          ? action?.payload
          : [];
        state.entitlementsSiteActivityTotalRecords = action?.payload
          ? action.payload[0].totalRecords
          : 0;
        state.isEntitlementsSiteActivityResultsFound =
          action.payload?.length === 0;
      })
      .addCase(fetchEntitlementsSiteActivity.rejected, (state, action) => {
        handleRejection(state, action);
        state.loading = false;
        state.entitlementsSiteActivityData = [];
        state.entitlementsSiteActivityTotalRecords = 0;
        state.isEntitlementsSiteActivityResultsFound = true;
        state.isEntitlementsLoading = false;
      })

      .addCase(entitlementSiteActivityJobRun.pending, (state, action) => {
        handlePending(state, action);

        state.siteActivityRunning = true;
        state.SAJobData = 0;
        state.SAJobRun = false;
      })
      .addCase(entitlementSiteActivityJobRun.fulfilled, (state, action) => {
        state.siteActivityRunning = false;
        state.SAJobData = action?.payload ? action?.payload : [];
        state.SAJobRun = true;
      })
      .addCase(entitlementSiteActivityJobRun.rejected, (state, action) => {
        handleRejection(state, action);
        state.siteActivityRunning = false;
        state.SAJobData = action?.payload ? action?.payload : [];
        state.SAJobRun = false;
      });
  },
});

export const {
  handleSelectedTab,
  handleEntitlementsSiteActivitySelectedRow,
  siteIdSet,
  setReq,
} = entitlementsSiteActivitySlice.actions;

export default entitlementsSiteActivitySlice.reducer;
